import React from 'react';
import '../../App.css';

const SettingsSlider = ({ min, max, value, onChange, unit = "px", step = 1 }) => (
  <div className="settings-range-container">
    <input 
      type="range" 
      min={min} 
      max={max} 
      step={step}
      value={value} 
      onChange={(e) => onChange(Number(e.target.value))} 
      className="settings-range" 
      style={{
        background: `linear-gradient(to right, #3b82f6 ${((value - min) / (max - min)) * 100}%, var(--track-bg, rgba(255,255,255,0.1)) ${((value - min) / (max - min)) * 100}%)`
      }}
    />
    <span className="settings-range-val">{value} {unit}</span>
  </div>
);

export default SettingsSlider;
